import React from 'react';
import { Thermometer, Droplets, Brush, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
export function HeatedSlabSection() {
  const points = [{
    icon: Droplets,
    title: 'Less Ice, But Still Wet',
    description: 'Heated slabs melt snow, but the surface stays wet. Traction still matters immensely.'
  }, {
    icon: Brush,
    title: 'Finish Affects Cleaning',
    description: 'Some finishes (exposed aggregate) are harder to sweep. Stamped patterns can trap standing water.'
  }, {
    icon: AlertTriangle,
    title: 'De-icing Behavior Changes',
    description: 'You use less salt, but any salt used interacts differently. Smooth finishes show salt stains more.'
  }, {
    icon: Thermometer,
    title: 'Thermal Cycling is Real',
    description: 'Heating creates more wet-dry and warm-cool cycles. This makes air entrainment and sealer strategy MORE important.'
  }];
  return <section className="py-16 bg-slate-900 text-white md:py-24" data-id="element-245">
      <div className="container mx-auto px-4 md:px-6" data-id="element-246">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-247">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-248">
            How Heating Changes the Equation
          </h2>
          <p className="mt-4 text-lg text-slate-300" data-id="element-249">
            A heated slab isn't just a regular slab that gets warm. It behaves
            differently.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-250">
          {points.map((point, index) => <Card key={index} className="bg-slate-800 border-slate-700 text-white hover:bg-slate-750 transition-colors" data-id="element-251">
              <CardContent className="p-6" data-id="element-252">
                <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4 text-primary-foreground border border-primary/30" data-id="element-253">
                  <point.icon className="h-6 w-6" data-id="element-254" />
                </div>
                <h3 className="font-bold text-lg mb-2" data-id="element-255">{point.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-256">
                  {point.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}